export const generateTreemapData = (size = 6) => {
  return Array.from({ length: size }, () => {
    const customersCount = Math.floor(Math.random() * 100) + 20
    const conversationsCount = Math.floor(customersCount * 0.7)
    const totalItems = Math.floor(conversationsCount * 0.4)
    const snapshotCount = Math.floor(Math.random() * 8) + 4

    return {
      id: "",
      label: "",
      description: "",
      customersCount,
      conversationsCount,
      totalItems,
      snapshotCount,
      snapshotLabels: [],
      snapshotIds: Array.from({ length: snapshotCount }, (_, i) => BigInt(i + 1)),
      avgSentiment: Number((Math.random() * 3 + 1).toFixed(1)),
      avgSolveRate: Number((Math.random() * 0.6 + 0.2).toFixed(1)),
      avgPotentialSolveRate: null,
      isNewTopic: false,
      streakInWeeks: 0,
    }
  })
}
